import { Box } from "theme-ui";

import { SvgOrImg } from "components";
import * as styles from "./ProductLogos.styles";

const Seperator = () => (
  <Box
    as="svg"
    width="12"
    height="24"
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    sx={styles.seperator}
  >
    <path d="M11 0H12L1 24H0L11 0Z" />
  </Box>
);

export default function ProductLogos({
  appLogo = {},
  productLogo = {},
  variantLogo = {},
  children,
  ...props
}) {
  return (
    <Box sx={styles.logos} {...props}>
      {appLogo?.url && (
        <Box
          as="img"
          src={appLogo.url}
          alt={appLogo?.alt}
          sx={styles.appLogo}
        />
      )}

      {productLogo?.url && (
        <>
          <Seperator />
          <SvgOrImg
            type={productLogo?.type}
            src={productLogo.url}
            alt={productLogo.alt}
            sx={{ ...styles.productLogo, ...productLogo.css }}
          />
        </>
      )}
      {children && (
        <>
          <Seperator />
          {children}
        </>
      )}
      {variantLogo?.url && (
        <>
          <Seperator />
          <SvgOrImg
            type={variantLogo?.type}
            src={variantLogo.url}
            alt={variantLogo.alt}
            sx={styles.variantLogo}
          />
        </>
      )}
    </Box>
  );
}
